import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../utils/translations';

const TranslationContext = createContext();

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};

export const TranslationProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState('English');

  useEffect(() => {
    // Load saved language from localStorage
    const savedLanguage = localStorage.getItem('selectedLanguage');
    if (savedLanguage && translations[savedLanguage]) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const changeLanguage = (language) => {
    if (translations[language] && currentLanguage !== language) {
      setCurrentLanguage(language);
      localStorage.setItem('selectedLanguage', language);
      // Dispatch custom event to notify other components
      window.dispatchEvent(new CustomEvent('languageChanged', { detail: language }));
    }
  };

  const t = (key) => {
    const translation = translations[currentLanguage]?.[key];
    if (translation) {
      return translation;
    }
    // Fallback to English
    const englishTranslation = translations['English']?.[key];
    if (englishTranslation) {
      return englishTranslation;
    }
    // If no translation found, return the key itself
    return key;
  };

  const value = {
    currentLanguage,
    changeLanguage,
    t,
    availableLanguages: Object.keys(translations)
  };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

